import type { TEAM_CATEGORY } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { TeamsTableDefinitionZod } from '../tables';

type Arguments = {
    category: TEAM_CATEGORY;
    position?: number;
};

export const schemaTeamResolver_ListByCategory = z.array(TeamsTableDefinitionZod);

export type SchemaTeamResolver_ListByCategory = z.infer<typeof schemaTeamResolver_ListByCategory>;

export type TeamResolver_ListByCategory = Resolver<Arguments, SchemaTeamResolver_ListByCategory>;
